import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getHistoricoFrequenciaPorAluno(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/frequencia/historico/', {params});
  return data;
}

type QueryFnType = typeof getHistoricoFrequenciaPorAluno;

function useHistoricoFrequenciaPorAluno(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-historico-frequencia-por-aluno', params],
    queryFn: () => getHistoricoFrequenciaPorAluno(params),
  });
}

export { getHistoricoFrequenciaPorAluno, useHistoricoFrequenciaPorAluno };
